import styled from 'styled-components';

export const DialogContent = styled.div`
  max-height: 85vh;
  overflow-y: auto;
  padding-right: 0.5em;
`;
